export default __webpack_public_path__ + "static/investment-management-38b025cc519f53e68b828f8981aed342.jpg";